<template>
  <div style="padding: 12px 12px;">

    <van-cell-group>
      <van-field
          placeholder="非必填"
          label="手机号"
          :value="mobile"
          @change="mobileChange"
      />
    </van-cell-group>


    <van-cell-group>
      <van-field
          placeholder=" "
          label="车牌号码"
          :value="brand_card"
          @change="brandCardChange"
      />
    </van-cell-group>



    <van-cell-group>
      <van-field
          placeholder=" "
          label="车型"
          :value="car_type"
          @change="carTypeChange"
      />
    </van-cell-group>

<!--    <van-cell is-link @click="choiceDate" :value="date">-->
<!--      <view slot="title">-->
<!--        <view class="van-cell-text">交车日期</view>-->
<!--      </view>-->
<!--    </van-cell>-->


    <van-field name="switch" label="交车日期">
      <template #input>
<!--        <van-switch v-model="switchChecked" size="20" />-->
      </template>
    </van-field>



    <van-cell-group>
      <van-field
          placeholder=" "
          label="施工店面"
          :value="store"
          @change="storeChange"
      />
    </van-cell-group>



    <van-cell-group>
      <van-field
          placeholder=" "
          label="施工部位"
          :value="part"
          @change="partChange"
      />
    </van-cell-group>


<!--    <van-cell :value="classify" is-link @click="choiceClassify">-->
<!--      <view slot="title">-->
<!--        <view class="van-cell-text">产品</view>-->
<!--      </view>-->
<!--    </van-cell>-->

    <van-field name="switch" label="产品">
      <template #input>
        <!--        <van-switch v-model="switchChecked" size="20" />-->
      </template>
    </van-field>


    <!--    <van-cell>-->
    <!--      <view slot="title">-->
    <!--        <view class="van-cell-text">膜批号</view>-->
    <!--      </view>-->
    <!--    </van-cell>-->

    <van-cell-group>
      <van-field
          placeholder=" "
          label="膜批号"
          :value="seri_no"
          @change="seriNoChange"
      />
    </van-cell-group>


    <!--    <van-cell is-link :value="year">-->
    <!--      <view slot="title">-->
    <!--        <view class="van-cell-text">施工质保年限</view>-->
    <!--      </view>-->
    <!--    </van-cell>-->

    <van-cell :border="false" style="margin-bottom: 24px;margin-top: 24px;">
      <view slot="title">
        <view class="van-cell-text">施工图</view>
      </view>
    </van-cell>


    <div style="padding: 12px 0;"></div>


    <div>
      <van-button type="primary" @click="uploadImg">上传质保图</van-button>
    </div>



    <div  style="margin-top: 24px;">
      <van-button type="primary" size="normal" block color="#222222;" v-on:click="doSearch">保存</van-button>
    </div>


    <van-popup
        :show="show_date"
        position="bottom"
    >

      <van-datetime-picker
          type="date"
          @input="onInput"
          @cancel="dateCancel"
          @confirm="dateConfirm"
          :value="currentDate"
          ref="date"
      />
    </van-popup>

  </div>
</template>

<script>
import moment from "moment"
import common from "@/assets/js/common";

export default {
  data () {
    return {
      msg: 'Hello',
      banners:{},
      src:'',
      list:[],
      title: '文章标题，你开来看呀，这个标题好长好长的呀',
      year: '',
      article: '',
      keyword: '',
      show: false,
      showType:false,
      showClassify: false,
      showYear: false,
      show_date: false,
      mobile: '',
      fileList:[],
      actions: [
        {
          name: '选项',
        },
        {
          name: '选项',
        },
        {
          name: '选项',
          subname: '副文本',
          openType: 'share',
        },
      ],
      brand: '请选择',
      type: '请选择',
      classify: '',
      brandObj: '',
      typeObj: '',
      classifyObj: '',
      classifyActions: [],
      columns: [],
      typeColumns: [],
      classifyColumns: [],
      carList: [],
      searchFlag: false,
      price: '',
      currentDate: new Date().getTime(),
      date:'',
      brand_card: '',
      car_type: '',
      store:'',
      part: '',
      seri_no: '',
      dealer_id: ''
    }
  },
  components: {
  },
  created:function()
  {

  },
  dateCancel(event, newval)
  {
    this.show_date = false
  },
  methods: {
    uploadImg()
    {
      wx.chooseImage(
          {
            count: 1,
            sizeType: ['original', 'compressed'],
            sourceType: ['album', 'camera'],
            success (res) {
              // tempFilePath可以作为img标签的src属性显示图片
              // const tempFilePaths = res.tempFilePaths
              alert(123)
              console.log('选择图片')
            }
          }
      )
    },

    seriNoChange(event)
    {
      this.seri_no = event.mp.detail
    },

    partChange(event)
    {
      this.part = event.mp.detail
    },

    storeChange(event)
    {
      this.store = event.mp.detail
    },

    carTypeChange(event)
    {
      this.car_type = event.mp.detail
    },

    mobileChange(event)
    {
      this.mobile = event.mp.detail
    },

    brandCardChange(event)
    {
      this.brand_card = event.mp.detail
    },

    onInput(event) {
      console.log('时间值更改')
      console.log(event.mp.detail)
    },



    deleteImg(event)
    {
      let ind = event.mp.detail.index
      this.fileList.splice(ind, 1)
    },

    afterRead(event)
    {

      let _self = this

      console.log('输出事件')
      console.log(event)


      const { file } = event.mp.detail;
      console.log('要开始上传图片了')

      wx.uploadFile({
        url: globalStore.state.host + 'index/album-image', // 仅为示例，非真实的接口地址
        filePath: file.path,
        name: 'images[]',
        success(res) {

          console.log('正常返回')
          let jsonData = JSON.parse(res.data);
          console.log(jsonData)
          if(jsonData.status)
          {
            // let path = globalStore.state.host + jsonData.data[0];
            // a.imgList[index].src = path;
            // a.imgList[index].uploadValue = jsonData.data[0];
            // a.$forceUpdate();


            // const { fileList = [] } = this.data;
            // fileList.push({ ...file, url: res.data });
            // this.setData({ fileList });


            let item =
                {
                  url: globalStore.state.host + jsonData.data[0],
                  name: '',
                  path: jsonData.data[0]
                }

            console.log(item)

            _self.fileList.push(item)

          }


          // 上传完成需要更新 fileList
          // const { fileList = [] } = this.data;
          // fileList.push({ ...file, url: res.data });
          // this.setData({ fileList });
        },
        fail(res){
          console.log('异常返回')
        }
      });




    },

    choiceDate(event)
    {
      console.log('选择日期')
      this.show_date = true
    },


    dateCancel(event, newval)
    {
      this.show_date = false
    },

    dateConfirm(event)
    {
      this.show_date = false
      console.log('获得confirm当前时间')
      // console.log(event.mp.detail.getValues())
      // console.log(this.$refs.date.value)
      console.log(event.mp.detail)
      let date = moment(event.mp.detail).format('YYYY-MM-DD')
      console.log(date)
      this.date = date
    },

    onCancel(event)
    {
      this.show = false
      this.showType = false
      this.showClassify = false
      console.log('取消')
    },
    onConfirm(event)
    {
      this.show = false
      // this.brand =
      console.log('确认')
      console.log(event.mp.detail)
      this.brand = event.mp.detail.value
      this.brandObj = event.mp.detail

      //设置具体型号的值
      let typeColumns = []
      let typeList = this.carList[event.mp.detail.index].subList
      console.log(typeList)
      for( let m = 0, n = typeList.length; m < n; m++ )
      {
        // brandActions.push({name: res.data.data.car_list[m].car_brand})
        typeColumns.push(typeList[m].sub_card_brand)
      }

      console.log('类型')
      console.log(typeColumns)

      // this.actions = brandActions
      this.typeColumns = typeColumns
      this.type = '请选择'
      this.$mp.page.selectComponent('#type_picker').setValues(this.typeColumns)
      // 设置为空值

    },
    onTypeConfirm(event)
    {
      this.showType      = false
      // this.brand =
      console.log('确认')
      console.log(event.mp.detail)
      this.type = event.mp.detail.value
      this.typeObj = event.mp.detail
    },
    onClassifyConfirm(event){
      this.showClassify = false
      // this.brand =
      console.log('确认')
      console.log(event.mp.detail)
      this.classify = event.mp.detail.value
      this.classifyObj = event.mp.detail
    },
    onChange(event)
    {
      console.log(event)
    },
    choiceBrand( event )
    {
      console.log('brand')
      // this.show = true
      // this.$mp.page.selectComponent('#brand_picker').setColumnIndex(0, 3)
      this.show = true
    },
    choiceType( event )
    {
      console.log('type')
      this.showType = true
    },
    choiceClassify( event )
    {
      console.log('classify')
      this.showClassify = true
    },
    onClose() {
      // this.setData({ show: false });
    },

    onSelect(event) {
      console.log(event.mp.detail);
    },
    doSearch()
    {

      console.log('查询报价')
      console.log(this.brand_card)


      if( !this.brand_card )
      {
        Dialog.alert({
          message: '请填写车牌号码',
        }).then(() => {
          // on close
        });
        return;
      }



      if( !this.car_type )
      {
        Dialog.alert({
          message: '请填写车型',
        }).then(() => {
          // on close
        });
        return;
      }

      if( !this.date )
      {
        Dialog.alert({
          message: '请选择交车日期',
        }).then(() => {
          // on close
        });
        return;
      }


      if( !this.store )
      {
        Dialog.alert({
          message: '请填写施工店面',
        }).then(() => {
          // on close
        });
        return;
      }


      if( !this.part )
      {
        Dialog.alert({
          message: '请填写施工部位',
        }).then(() => {
          // on close
        });
        return;
      }

      if( !this.classify )
      {
        Dialog.alert({
          message: '请选择产品',
        }).then(() => {
          // on close
        });
        return;
      }


      if( !this.seri_no )
      {
        Dialog.alert({
          message: '请填写膜批号',
        }).then(() => {
          // on close
        });
        return;
      }


      if( !this.fileList.length )
      {
        Dialog.alert({
          message: '请至少上次一张施工图',
        }).then(() => {
          // on close
        });
        return;
      }

      //
      // if( this.type == '请选择' )
      // {
      //   Dialog.alert({
      //     message: '请选择型号',
      //   }).then(() => {
      //     // on close
      //   });
      //   return;
      // }
      //
      // if( this.classify == '请选择' )
      // {
      //   Dialog.alert({
      //     message: '请选择系列',
      //   }).then(() => {
      //     // on close
      //   });
      //   return;
      // }

      //执行查询操作
      Toast.loading({
        mask: true,
        message: '提交中...',
        duration: 0
      });


      this.searchFlag = true

      let url = globalStore.state.host + 'index/add-qua';
      let requestParam = {code:1}

      //处理质保图


      Object.assign(requestParam,{
        // classify: this.classify, type: this.type
        mobile: this.mobile,
        brand_card: this.brand_card,
        car_type: this.car_type,
        store: this.store,
        part: this.part,
        date: this.date,
        product: this.classify,
        seri_no: this.seri_no,
        imgs: JSON.stringify(this.fileList),
        dealer_id: '',
        quality_id: ''
      });
      this.$http.get(url,requestParam).then((res)=>{
        Toast.clear()
        if( res.data.status )
        {
          // this.price = res.data.data

          //TODO
          // wx.navigateBack({})
          wx.redirectTo({
            url: '/pages/deal/main'
          })
        } else
        {
          //弹出错误
          Dialog.alert({
            message: '操作失败',
          }).then(() => {
            // on close
          });
        }
      }).catch(err=>{
        Toast.clear()
      })


    },
    searchChange(event)
    {
      this.keyword = event.mp.detail
    }
  },
  onShow(){
  },
  mounted() {


    //
    common.commonHttp('/index/wechat-sign-package?url=' + location.href,{}).then((res)=>{

      console.log(res)
      console.log('配置返回值')

      if( res.data.status == 1 )
      {
        // let signPackage = res.datasign_package
        // this.wxchooseImageType = JSON.parse(res.data.choose_img_source_type)
        wx.config({
          debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.data.signature,// 必填，签名
          jsApiList: ['uploadImage','chooseImage','previewImage','uploadImage','getLocalImgData'] // 必填，需要使用的JS接口列表
        })

        // alert(123)
      }
    })


    // this.wxchooseImageType = JSON.parse(res.data.choose_img_source_type)
    // wx.config({
    //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   appId: signPackage.appId, // 必填，公众号的唯一标识
    //   timestamp: signPackage.timestamp, // 必填，生成签名的时间戳
    //   nonceStr: signPackage.nonceStr, // 必填，生成签名的随机串
    //   signature: signPackage.sign,// 必填，签名
    //   jsApiList: ['uploadImage','chooseImage','previewImage','uploadImage','getLocalImgData'] // 必填，需要使用的JS接口列表
    // })
  }
}
</script>

<style scoped>
.message {
  color: red;
  padding: 10px;
  text-align: center;
}

.bill-panel{background: #FFFFFF;
  box-shadow: 0 2px 6px 0 #E7E9F0;
  border-radius: 5px;padding: 16px;}

.quality-title
{
  font-size: 14px;
  color:rgba(0,0,0, 1);
  font-weight: 600;
  margin: 12px 0;
}

.quality-content
{
  font-size: 12px;
  line-height: 20px;
  color:rgba(0,0,0, .4);
}

.wrapper
{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
